import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, AlertContainer } from 'react-bs-notifier';

import { hideAlert } from '../../actions/radminUploads';

const AlertNotifier = () => {
  const alert = useSelector((state) => state.radAdmin.alert);
  const dispatch = useDispatch();

  const onDismiss = useCallback(() => {
    dispatch(hideAlert());
  }, [dispatch]);

  return (
    <AlertContainer>
      {alert.active && <Alert {...alert} onDismiss={onDismiss} />}
    </AlertContainer>
  );
};

export default AlertNotifier;
